import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import { trackPageVisit } from "Common/components/tracking/trackingService";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";

class PageTracker extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            pageTitle:
                EntityBuilder.of(this.props.data, { inplace: true })
                    .getChild("title")
                    .getValue() || "Page name not defined in Database"
        };
    }
    componentDidMount() {
        if (this.props.data) {
            trackPageVisit(this.state.pageTitle);
        }
    }

    render() {
        return null;
    }
}

export default webui.connectComponent()(PageTracker);
